import { css } from 'styled-components';
import { FontFaceItem, FontFaceTheme, FontFamilyByLanguageTheme } from '@kite-js/theme';
import { Heading, Input, Paragraph, Select, Span, Textarea } from '@kite-js/core';

/**
 * WORKAROUND FOR https://github.agodadev.io/agoda-front-end/kite-js/issues/653
 * Refer to CssBaseline once fonts theming fixed
 * https://github.agodadev.io/agoda-front-end/kite-js/blob/v0.17.6/packages/core/src/CssBaseline/fonts.tsx
 */
const formatFontFace = (fontFace: FontFaceItem, fontFamily: string) => {
    const fontWeight = fontFace.fontWeight ? `font-weight: ${fontFace.fontWeight}` : '';
    return `
        @font-face {
            font-family: '${fontFamily}';
            src: ${fontFace.primarySrc};
            src: ${fontFace.secondarySrc};
            ${fontWeight};
            font-style: ${fontFace.fontStyle};
        }
    `;
};

const formatFontFaceFamily = (font: FontFaceTheme) =>
    font.fontFaces.reduce(
        (templateLiteral: string, item: FontFaceItem) => templateLiteral + formatFontFace(item, font.fontFamily),
        ''
    );

const formatFontFamilyByLanguage = (font: FontFamilyByLanguageTheme) => {
    const selector = font.lang ? `kite-lang='${font.lang}'` : 'kite-lang';
    return `
        html[${selector}] ${Span.Style},
        html[${selector}] ${Paragraph.Style},
        html[${selector}] ${Heading.Style},
        html[${selector}] .kite-js-DEPRECATED_Text,
        html[${selector}] ${Input.Style},
        html[${selector}] ${Select.Style},
        html[${selector}] .kite-js-Typography,
        html[${selector}] .kite-js-Table,
        html[${selector}] .kite-js-TableBody,
        html[${selector}] .kite-js-TableCell,
        html[${selector}] .kite-js-TableHead,
        html[${selector}] .kite-js-TableRow,
        html[${selector}] ${Textarea.Style} {
            font-family: ${font.families.join(',')};
        }
    `;
};

const fonts = css`
    ${props =>
        props.theme.font.faces.reduce(
            (templateLiteral: string, n: FontFaceTheme) => templateLiteral + formatFontFaceFamily(n),
            ''
        )}
    ${props =>
        props.theme.font.familiesByLanguage.reduce(
            (templateLiteral: string, n: FontFamilyByLanguageTheme) => templateLiteral + formatFontFamilyByLanguage(n),
            ''
        )}
    color: ${props => props.theme.font.defaultColor};
`;

export default fonts;
